import FileSaver from 'file-saver';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

import { stateToZip, zipToState } from '~app/core/zip';
import { t } from "~app/AppBundleContext";
import { clearNodes, loadNodes, loadHeader } from './nodeList';
import { startLoading, finishLoading, createMessage, setAppVersion } from './app';

import Logging from '~app/core/logging';

const log = Logging.getLogger('app.actions.local');

export function saveToLocal(fileName) {
  return async (dispatch) => {

    try {
      const saveAsBlob = true;
      const fileData = await dispatch(stateToZip(saveAsBlob));
      FileSaver.saveAs(fileData, fileName);

      dispatch(createMessage(t("file-saved"), "success"));
    }
    catch(error) {
      dispatch(createMessage(t("failed-save-file"), "danger"));
      log.error(`Failed to save file: ${error}`);
    }
  };
}

export function loadFromLocal(file) {
  return async (dispatch) => {
    dispatch(startLoading(t("loading-file")));

    try {
      const savedState = await dispatch(zipToState(file));
      const { nodes, header, version } = savedState;

      dispatch(clearNodes());
      dispatch(loadNodes(nodes));
      dispatch(loadHeader(header));
      dispatch(setAppVersion(version));

      dispatch(UndoActionCreators.clearHistory());
    
      dispatch(createMessage(t("file-loaded"), "success"));
    }
    catch(error) {
      dispatch(createMessage(t("failed-load-file"), "danger"));
      log.error(`Failed to load file: ${error}`);
    }

    dispatch(finishLoading());
  };
}



// WEBPACK FOOTER //
// ./src/actions/local.js